import Footer from "../Common/Footer";
import Header from "../Common/Header";

import React, { useEffect } from "react";

function Privacy() {


    
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <>
    <Header/>
    <div style={{backgroundImage:"url(" + "assets/img/bg/breadcumb-bg.jpg" + ")", backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize:'cover'}}
      className="breadcumb-wrapper"
    
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Privacy Policy</h1>
          
        </div>
      </div>
    </div>
    <div className="space">
      <div className="container">
        
        <div className="row">
        <div className="entry-content">
  <p>
    <strong>INTRODUCTION</strong>
  </p>
  <p>
    <strong>
      Shvetdhara is the licensed owner of the brand
      Gaj Milk and the website www.Shvetdhara.com (“The Website”)
    </strong>
  </p>
  <p>
    We value your privacy. This Privacy Policy informs you of your choices and
    our practices regarding any Information you provide to us.
    <br />
    The use of our services may involve the collection and use of your
    Information (as defined in the “The Information We Collect and How We
    Collect It” section below) on our services (including our website:&nbsp;
    <a href="https://www.Shvetdhara.in/">https://www.Shvetdhara.in</a>)
  </p>
  <p>
    It is important for you to understand how this happens and how you may
    control it, so please read this Privacy Policy carefully.
  </p>
  <p>
    <strong>
      By using our services, you agree that we may collect, use and share your
      Information in accordance with this Privacy Policy, as revised from time
      to time.
    </strong>
  </p>
  <p>
    <strong>SCOPE OF THIS PRIVACY POLICY</strong>
  </p>
  <p>
    This Privacy Policy applies across all of our services as defined above.
    <br />
    This Privacy Policy is incorporated into and form part of the&nbsp;
    <strong>
      <em>Shvetdhara Dairy Private Limited</em>
    </strong>
    <em> Terms of Service</em>&nbsp;that you have agreed to in order to use our
    services. Any terms used in this Privacy Policy will have the same meaning
    as the equivalent defined terms in{" "}
    <strong>
      <em>Shvetdhara Dairy Private Limited</em>
    </strong>
  </p>
  <p>
    Terms of Service, unless otherwise defined in this Privacy Policy or the
    context requires otherwise.
    <br />
    Please also note that this Privacy Policy does not apply to Information
    collected:
  </p>
  <ol>
    <li>
      Through third party services (including any third party websites) that you
      may access through our services; or
    </li>
    <li>
      By other companies and organizations who advertise their services on our
      services.
    </li>
  </ol>
  <p>
    <strong>CHANGES TO THIS PRIVACY POLICY</strong>
  </p>
  <p>
    We may from time to time revise or add specific instructions, policies and
    terms to this Privacy Policy. These instructions, policies and terms form
    part of this Privacy Policy.
    <br />
    Where we consider that any changes to this Privacy Policy are reasonably
    material, we will notify you (via our https://shvetdhara.com/), direct
    communication to you, or other means) prior to the change becoming
    effective. By continuing to use our services after any changes to this
    Privacy Policy, with or without notice from us,you are agreeing to the
    revised Privacy Policy.
  </p>
  <p>
    <strong>THE INFORMATION WE COLLECT AND HOW WE COLLECT IT</strong>
  </p>
  <p>
    In providing our services, we collect, store and use the following
    Information relating to you:
    <br />“<strong>Information</strong>” is Personal Information and
    Non-Personal Information;
    <br />“<strong>Personal Information</strong>” is any information or
    combination of information that relates to you, and can be used to identify
    you. Personal Information may include the following:
  </p>
  <ul>
    <li>
      information you make available to us when you open an account or use our
      services, such as your name, telephone number and email address;
    </li>
    <li>
      information which you make available to our services as you use them,
      including Shared Information you make available to others through our
      services and information you store using our services;
    </li>
    <li>
      Shared Information that others using our services make available about
      you, such as information contained in posts they make and communications
      they make to you and others using our services; and
    </li>
    <li>
      information we collect as you use our services, such as certain Location
      Data and Log Data.
    </li>
  </ul>
  <p>
    “<strong>Location Data</strong>” is information that we collect regarding
    your location (when you use a location-enabled service), including:
  </p>
  <ul>
    <li>
      the location of your device when you use our services, such as from the
      GPS, WiFi, compass, accelerometer or other sensors in your mobile device;
    </li>
    <li>
      the IP address of the device or internet service you use to access our
      services,
    </li>
    <li>
      other information made available by you or others that gives an indication
      as to where you are or have been located, such as account information that
      indicates where you are located and Shared Information you or others post
      indicating your location, such as any geotag information that is embedded
      in any photos you make available to us; and
    </li>
    <li>
      if you have provided us with your location data previously and would like
      us to delete such existing location data, you may be able to do so via our
      services.
    </li>
  </ul>
  <p>
    “<strong>Log Data</strong>” is technical information that is automatically
    collected by us when you use our services, whether through the use of
    cookies, web beacons and log files (as explained in more detail in the
    “Cookies, Web Beacons and Log Files” section below) or otherwise, including:
  </p>
  <ul>
    <li>
      Technical information such as your mobile carrier, configuration
      information made available by your web browser or other programs you use
      to access our services, your IP address and your device’s version and
      identification number,
    </li>
    <li>
      Information about what you have searched for and looked at while using our
      services, such as web search terms used, social media profiles visited and
      details of other information and content accessed or requested by you in
      using our services;
    </li>
    <li>
      Information about communications you have made using our services, such as
      the people you’ve communicated with and the time, data and duration of
      your communications; and
    </li>
    <li>
      Metadata, which means information related to items you have made available
      through our services, such as the date, time or location that a shared
      photograph or video was taken or posted.
    </li>
  </ul>
  <p>
    “<strong>Non-Personal Information</strong>” is any information that relates
    to you but from which it is not practicable to directly or indirectly
    identify you, including Personal Information in aggregated, anonymised or
    pseudonymised form.
  </p>
  <p>
    “<strong>Shared Information</strong>” is information about you or relating
    to you that is voluntarily shared on our services, including postings that
    you make on our services (including your public profile, the lists you
    create), any postings from others that you re-post and including Location
    Data and Log Data associated with these postings. Shared Information also
    includes information about you (including Location Data and Log Data) that
    others who are using our services share about you.
  </p>
  <p>
    <strong>HOW WE USE YOUR INFORMATION</strong>
  </p>
  <p>We may use your Information for any of the following purposes:</p>
  <ul>
    <li>To provide our services to you;</li>
    <li>
      For customer service, security, fraud-detection, archival and backup
      purposes in connection with the provision of our services;
    </li>
    <li>
      To provide you with advertising and direct marketing that is more relevant
      to you (as discussed in more detail below under the “Direct Marketing”
      section below);
    </li>
    <li>
      To better understand how you access and use our services, for the purposes
      of trying to improve our services and to respond to customer desires and
      preferences, including language and location customisation, personalised
      help and instructions, or other responses to your and other customers’
      usage of our services;
    </li>
    <li>
      To help us develop our new services and improve our existing services;
    </li>
    <li>
      To assess the effectiveness of and improve advertising and other marketing
      and promotional activities on or in connection with our services when your
      account is subscribed to an official account; and
    </li>
    <li>
      To allow you to participate in surveys about our products and services. If
      you participate in a survey, we may request certain personally
      identifiable information from you. Participation in these surveys is
      voluntary and you therefore have a choice whether or not to disclose this
      information. We use may use a third party service provider to conduct
      these surveys and such third party service provider will be prohibited
      from using your personally identifiable information for any other purpose.
    </li>
  </ul>
  <p>
    <strong>
      Please note that for the purposes of seeking to provide our users with a
      better experience, to improve our services or otherwise where you have
      consented, Personal Information collected through our site or service may,
      subject to user privacy controls (where available), be used by our other
      services (including in an aggregated or individualised manner).
    </strong>
    <br />
    <strong>
      For example, Personal Information collected during your use of one of our
      services may be used to suggest particular content that can be made
      available to you on another service or be used to try to present more
      relevant advertising to you in another service. You may also from time to
      time ask us to migrate or export your Personal Information contained in
      one of our services to another of our services, where such migration
      option is available.
    </strong>
    <br />
    If any of your Personal Information comprises Your Content (as defined in
    the Shvetdhara Dairy Farms Pvt. Ltd.<strong>&nbsp;</strong>Terms of Service),
    we and our affiliate companies may (subject to this Privacy Policy) use such
    Personal Information in accordance with the “Your Content” section of the
    Shvetdhara Dairy Farms Pvt. Ltd.
  </p>
  <p>
    <strong>COOKIES, WEB BEACONS AND LOG FILES</strong>
  </p>
  <p>
    We may use cookies, web beacons and log files to collect, and store
    Information about you or relating to you. We further describe how we use
    cookies, log files and web beacons in our&nbsp;<em>Cookies Policy</em>.
  </p>
  <p>
    <strong>SHARING OF YOUR PERSONAL INFORMATION</strong>
  </p>
  <p>
    <strong>
      Other than as permitted under this Privacy Policy or as otherwise
      consented to by you, we will not transfer your Personal Information to any
      other third parties for their processing for any purposes.
    </strong>
    <br />
    We and our affiliate companies may share your Personal Information within
    our group of companies and with joint venture partners and third party
    service providers, contractors and agents (such as communication service
    providers who send emails or push notifications on our behalf, and mapping
    services providers who assists us and you with location data), in each case,
    for the purposes of:
  </p>
  <ol>
    <li>Providing our services to you;</li>
    <li>
      Assisting us in carrying out the purposes set out under the “How We Use
      Your Information” section above;
    </li>
    <li>
      Carrying out our obligations and enforcing our rights under the Shvetdhara
      Dairy Farms Pvt. Ltd.<strong>&nbsp;</strong> Terms of Service or this
      Privacy Policy; and/or
    </li>
    <li>
      Help understand and improve our services. These third parties may be
      located, and use and store your Personal Information, outside of your
      jurisdiction for these purposes.
    </li>
  </ol>
  <p>
    Where we or our affiliate companies do share your Personal Information with
    any third parties, we will use reasonable efforts to ensure that such third
    parties only use your Personal Information:
  </p>
  <ol>
    <li>In compliance with this Privacy Policy; and</li>
    <li>
      Subject to any other instructions we give them, including any appropriate
      confidentiality and security measures that we implement.
    </li>
  </ol>
  <p>
    <strong>
      You consent to the third party use, sharing and transfer of your Personal
      Information (both inside and outside of your jurisdiction) as described in
      this section.
    </strong>
    <br />
    We allow third parties such as analytics providers and advertising partners
    to collect your Personal Information over time and across different websites
    or online services when you use our services.
    <br />
    As we continue to develop our business, we or our affiliate companies may be
    acquired by a third party or re-organise our group structure. In these
    circumstances, it may be the case that your Information is transferred
    within our group and/or transferred to a third party who will continue to
    operate our services or similar services under either this Privacy Policy or
    a different privacy policy which will be notified to you. The party to which
    your Personal Information is transferred may be located, and use your
    Information, outside of your jurisdiction.
    <br />
    You agree that we or our affiliate companies may be required to retain,
    preserve or disclose your Personal Information:
  </p>
  <ol>
    <li>In order to comply with applicable laws or regulations;</li>
    <li>
      In order to comply with a court order, subpoena or other legal process;
    </li>
    <li>
      In response to a request by a government authority, law enforcement agency
      or similar body (whether situated in your jurisdiction or elsewhere); or
    </li>
    <li>
      Where we believe it is reasonably necessary to comply with applicable laws
      or regulations. You also agree that we or our affiliate companies may need
      to disclose your Personal Information in order to enforce the{" "}
      <strong>Shvetdhara Dairy Farms Pvt. Ltd.&nbsp;</strong>Terms of Service or
      this Privacy Policy, protect our rights, property or safety, or the
      rights, property or safety of our affiliate companies or other users of
      our services.
    </li>
  </ol>
  <p>
    <strong>A WORD ABOUT SHARED INFORMATION</strong>
  </p>
  <p>
    <strong>
      Our service enable Shared Information to be shared publicly with all users
      of that service and not just your contacts. Our social media services in
      particular are primarily designed to help you share Shared Information
      with the world via features either provided by us or third parties, so
      Shared Information can be broadly and instantly transmitted and will
      remain public for as long as you do not delete it (and even after you
      delete Shared Information, it may still be separately cached, copied, or
      stored by, or remain public through, other users or third parties who are
      not affiliated with and not controlled by us).
    </strong>
    <br />
    <strong>
      Please consider carefully what you post and communicate through our
      services.&nbsp;
    </strong>
    In some instances, you may control what access the wider public has to your
    Shared Information via the privacy settings in some of our services. If you
    would like to update or amend your Personal Information you may do so by
    logging into your account and making the appropriate changes or by
    contacting our Privacy Officer. To request removal of your Personal
    Information from our services, or to request the removal of an unauthorized
    account, please contact our Privacy Officer. In some cases, we may not be
    able to update, amend or remove your Personal Information, in which case we
    will let you know why we are unable to do so.
  </p>
  <p>
    <strong>COMMUNICATIONS FROM US</strong>
  </p>
  <p>
    <em>Newsletters and other types of communications</em>
    <br />
    When you use our service, we may use your Information to send you emails,
    newsletters or push notifications to your device. If you no longer wish to
    receive these communications, you can do so by following the unsubscribe
    instructions in the emails we send to you, opting out of notifications at
    the device level (if available) or contacting our Privacy Officer via the
    contact information within this Policy.
    <br />
    <em>Service-related announcements</em>
    <br />
    We may from time to time send you service-related announcements when we
    consider it necessary to do so (such as when we temporarily suspend one of
    our services for maintenance). You may not opt-out of these service-related
    announcements, which are not promotional in nature.
  </p>
  <p>
    <strong>A WORD ABOUT SENSITIVE PERSONAL INFORMATION</strong>
  </p>
  <p>
    In some jurisdictions, certain Personal Information, such as information
    about your race or ethnic origin, religious or philosophical views or
    personal health, is characterised as “sensitive” and is subject to stricter
    regulation than other personal information. Please note that content and
    information that you input to our services, such as photographs or
    information about your school or social activities, may reveal your
    sensitive Personal Information to others.
    <br />
    We urge you to consider whether it is appropriate to communicate Personal
    Information of a sensitive nature in the manner you are proposing to
    communicate it using our services.
  </p>
  <p>
    <strong>
      You consent to all processing of sensitive Personal Information for the
      purposes and in the manner described in this Privacy Policy.
    </strong>
    <br />
    Please note that we do not use your sensitive Personal Information for the
    purpose of serving advertising to you.
  </p>
  <p>
    <strong>THIRD PARTY SERVICES ON OUR SERVICES</strong>
  </p>
  <p>
    Our service may link you to, social media or other services (including
    websites) provided by a third party. For example:
  </p>
  <ul>
    <li>
      You may be able to share content on, or login to, our services using
      services provided by third parties. The third parties who provide such
      services may be able to collect your Information and Personal Information
      (including your Log Data), and may set cookies on your computer to enable
      such feature to function properly; and
    </li>
    <li>
      We may (whether in advertisements or otherwise within our services)
      provide you with links that allow you to access third party services or
      websites.
    </li>
  </ul>
  <p>
    These third party social media or other services may be hosted by the
    relevant third party or us. Your use of any such third party services
    (whether social media services or otherwise), including any Personal
    Information you provide to such third parties, are subject to the relevant
    third party’s own terms of services and privacy policies and not the
    Shvetdhara Dairy Farms Pvt. Ltd.<strong>&nbsp;</strong>Terms of Service or
    this Privacy Policy, so please review their terms carefully. This Privacy
    Policy only applies to any Information collected by us, does not apply to
    any services offered by or information practices of any third parties, and
    we bear no liability for any third party use of any Information provided by
    you to them.
  </p>
  <p>
    <strong>AGE RESTRICTIONS</strong>
  </p>
  <p>
    Children under the age of 13 are not allowed to use our services. We do not
    knowingly collect Personal Information from any children under the age of
    13. Please contact our Privacy Officer if you believe we have any Personal
    Information from any children under the age of 13 and we will promptly
    investigate (and remove) such Personal Information.
  </p>
  <p>
    <strong>TRANSFER, STORAGE AND SECURITY OF YOUR PERSONAL INFORMATION</strong>
  </p>
  <p>
    We operate and may continue to operate servers in a number of jurisdictions
    around the world, so the server on which your Personal Information is used
    and stored may not be in your jurisdiction.
  </p>
  <p>
    <strong>
      You consent to the transfer of your Personal Information (both inside and
      outside of your jurisdiction) for the purposes described in this Privacy
      Policy.
    </strong>
    <br />
    We use a variety of security technologies and procedures for the purpose of
    preventing loss, misuse, unauthorised access or disclosure of Information.
    <br />
    In our service, we will use encryption technology (such as SSL) to protect
    certain sensitive Information (such as location data) provided by you to us.
    Please be aware that despite our efforts, no data security measures can
    guarantee 100% security at all times. Our systems and the communications
    networks through which you access our services may be subject to security
    breaches and failures which are due to circumstances beyond our reasonable
    control. If you have any questions regarding the security of your Personal
    Information, please contact our Privacy Officer.
  </p>
  <p>
    <strong>PERIOD OF USE OF YOUR PERSONAL INFORMATION</strong>
  </p>
  <p>
    Subject to applicable laws and regulations (including as set out under the
    “Sharing of your Personal Information” section above), we will only use your
    Personal Information for so long as is necessary to fulfill the purposes as
    set out under the “How We Use Your Information” section above.
    <br />
    Subject to applicable laws and regulations, you may have the right to
    request to receive a copy of and make any corrections to your Personal
    Information which we hold, and to request that we deactivate and not use any
    of your Personal Information that is stored by us. You may direct such
    request to our Privacy Officer, or where we offer this option in our
    services, you may also log into your account with us and make the
    appropriate changes. We will respond to all requests made to our Privacy
    Officer under this “Retention of your Personal Information” section within
    60 days.
    <br />
    Should your account be terminated by you or us for any reason, we will
    (subject to the above paragraph) take steps to ensure that your Personal
    Information is no longer available through our services, or otherwise used
    by us, within a reasonable period of time (subject to technical limitations)
    after such account termination. However, it is important to note that
    communications made by you using our services may put your Personal
    Information in the hands of third parties that we cannot control.
  </p>
  <p>&nbsp;</p>
</div>


        </div>
      </div>
    </div>
   
  
    <Footer />
  </>
  
  );
}

export default Privacy;
